import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IORTHOPAY_SESSION_KEY } from '@core/classes/global-conts';
import { TenantService } from '@core/services/tenant.service';
import { environment } from '@environment/environment';
import { SessionStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {

  constructor(
    private sessionStorage: SessionStorageService,
    private tenantsService: TenantService
  ) {

  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    if (!req.url.includes("http"))
      return next.handle(req);


    const backendToken = environment.token.apiItek;
    const agentId = this.sessionStorage.retrieve('agentId');
    const agentLang = this.sessionStorage.retrieve('agentLang');
    const tenantId = this.tenantsService.getActiveTenant();

    const session = this.sessionStorage.retrieve(IORTHOPAY_SESSION_KEY);

    //buscar sempre o bypass
    const userId = session
    ? session.bypass_as
      ? String(session.bypass_as?.user?.id)
      : session.user
        ? String(session.user.id)
        : '0'
    : '0';

    const claims_hash = session
    ? session.bypass_as
      ? String(session.bypass_as?.user?.claims)
      : session.user
        ? String(session.user.claims)
        : '-1'
    : '-1';

    let newReq: HttpRequest<any>;


    newReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Access-Control-Allow-Origin': '*',

        "x-tenant-id": tenantId,
        "x-agent-id": agentId,
        "x-agent-lang": agentLang,
        "x-user-id": userId,
        "x-user-claims": claims_hash,

        'token': `${backendToken}`
      }
    });



    return next.handle(newReq);
  }
}
